var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"m-2 p-4 elevation-5"},[_c('b',[_vm._v(_vm._s(_vm.i)+". "+_vm._s(_vm.t)+" ")]),_vm._v(" ("+_vm._s(_vm.h)+" %) "),_c('v-progress-linear',{attrs:{"striped":"","height":"10","value":_vm.h,"buffer-value":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }